// extracted by mini-css-extract-plugin
export default {"name":"nmayghkOt8BNwVvEWWVD","role":"DFQbkRPcJYG8zmQZEcF2","profilelist":"r71f3cv_4VcYnnx6UFj9","digitfocus":"YBMeu0nxuf4Lh1J3kjPt"};